// Dimensionless proportions measured from published Figure 5. SVG and DOT
// share these sizes so routing reserves the same space that the marks occupy.
export const diagramStyle = {
  green: '#9dcd9b',
  ink: '#000',
  draw: '#7f7f7f',
  red: '#ed001b',
  selection: '#eacb43',
  circleRadius: 6.8,
  squareSide: 6.8,
  compressedWidth: 2.345,
  compressedDash: '0.2345 1.1725',
  neutralWidth: 0.38,
};
export type CheckMode = 'retained' | 'assessed';
